import React from "react";
import { Sparkles } from "lucide-react";
import PWAInstallButton from "../PWAInstallButton";

const MobileHeader: React.FC = () => {
    return (
        <header className="md:hidden fixed top-0 left-0 right-0 h-16 bg-black/80 backdrop-blur-2xl border-b border-white/5 z-50 flex items-center justify-between px-4">
            <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center shadow-lg shadow-primary/20">
                    <Sparkles className="text-white" size={18} />
                </div>
                <span className="font-bold text-lg tracking-tight bg-gradient-to-r from-white to-white/60 bg-clip-text text-transparent">
                    InstaCommenter
                </span>
            </div>

            <PWAInstallButton
                showLabel={false}
                className="!bg-primary/10 !text-primary hover:!bg-primary hover:!text-white !p-2 !rounded-xl !border-0"
            />
        </header>
    );
};

export default MobileHeader;
